import { render, staticRenderFns } from "./CaseLedgerPDFMake.vue?vue&type=template&id=82dcb4da"
import script from "./CaseLedgerPDFMake.vue?vue&type=script&lang=js"
export * from "./CaseLedgerPDFMake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports